import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "75%",
    height: "87%",
    backgroundColor: theme.palette.primary.main,
    borderRadius: "20px",
    padding: "24px",
    boxShadow: "0px 19px 45px 0px #0000001F",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: "18px",
  },
  leftSidebarContainer: {
    width: "240px",
    backgroundColor: "#252A38",
    height: "100%",
    padding: "10px",
    borderRadius: "10px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  singleSidebarItem: {
    width: "100%",
    backgroundColor: "#1B1D28",
    // height: "100%",
    padding: "8px 12px",
    borderRadius: "6px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  sidebarGrayText: { color: "#606479", fontSize: "12px" },
  inviteButton: {
    border: `2px solid ${theme.palette.secondary.main}`,
    height: "40px",
    minWidth: "150px",
    textTransform: "none",
    padding: "6px ",
    borderRadius: "7px",
    color: theme.palette.text.secondary,
    "&:hover": {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.secondary.light,
    },
    fontSize: "14px !important",
  },
  iconButton: {
    borderRadius: "10px !important",
    border: `2px solid ${theme.palette.secondary.main} !important`,
  },
  tabs: {
    textTransform: "none !important",
  },
  tableHeaderCell: {
    borderBottom: `1px solid ${theme.palette.secondary.light} !important`,
    backgroundColor: "transparent !important",
    color: `${theme.palette.text.tertiary} !important`,
    width: "25%",
  },
  tableCell: {
    borderBottom: `1px solid ${theme.palette.secondary.light} !important`,
    color: "#fff !important",
    width: "25%",
  },
  menuItem: {
    color: "#fff",
    borderRadius: "8px",
    padding: "12px 16px",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    "&:hover": {
      backgroundColor: "#3E4759",
    },
  },
  listIcon: {
    minWidth: "max-content !important",
    color: "#fff",
  },
  listText: {
    fontSize: "14px",
    color: "#fff",
  },
  button: {
    backgroundColor: `${theme.palette.secondary.main} !important`,
    width: "200px",
    color: "#fff",
    borderRadius: "10px !important",
    padding: "12px 16px",
    fontSize: "14px",
  },
  footer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  flexCenter: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  // invite to project modal styles
  inviteToProjectModalRoot: {
    width: "40%",
    // height: "87%",
    backgroundColor: theme.palette.primary.main,
    borderRadius: "20px",
    padding: "24px",
    boxShadow: "0px 19px 45px 0px #0000001F",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  cardContentDiv3: {
    backgroundColor: theme.palette.secondary.light,
    padding: "4px",
    borderRadius: "10px",
  },
  cardContentInput1: {
    padding: "0.2px 6px",
  },
}));

export default useStyles;
